import { render, staticRenderFns } from "./BrandMainPage.vue?vue&type=template&id=374d5422&lang=pug"
import script from "./BrandMainPage.vue?vue&type=script&lang=js"
export * from "./BrandMainPage.vue?vue&type=script&lang=js"
import style0 from "./BrandMainPage.vue?vue&type=style&index=0&id=374d5422&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports